import utc from 'dayjs/plugin/utc'
import dayjs from "dayjs";

dayjs.extend(utc)


export default dayjs
